/**
 * CookieBanner - Banner cookie con link alla Cookie Policy e pulsante Accetta
 * La preferenza viene salvata in localStorage (cookie_consent) per non mostrare di nuovo il banner.
 */

import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Link } from '@mui/material';

const STORAGE_KEY = 'cookie_consent';

export const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const accepted = localStorage.getItem(STORAGE_KEY);
      if (!accepted) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
      setVisible(false);
    } catch {
      setVisible(false);
    }
  };

  if (!visible) return null;

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: 2,
        px: { xs: 2, sm: 3 },
        py: 2,
        borderRadius: 0,
        bgcolor: 'rgba(0, 26, 77, 0.98)',
        borderTop: '2px solid #FFCC00',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2
      }}
    >
      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.95)', flex: '1 1 280px', maxWidth: 720 }}>
        Utilizziamo cookie e tecnologie simili (local storage) per il funzionamento del sito e, con il tuo consenso, per analisi anonime delle visite.{' '}
        <Link
          href="?page=cookie-policy"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: '#FFCC00', fontWeight: 600, textDecoration: 'underline' }}
        >
          Cookie Policy
        </Link>
      </Typography>
      <Box sx={{ flexShrink: 0 }}>
        <Button
          variant="contained"
          size="medium"
          onClick={handleAccept}
          sx={{
            bgcolor: '#FFCC00',
            color: '#003399',
            fontWeight: 700,
            '&:hover': { bgcolor: '#e6b800' }
          }}
        >
          Accetta
        </Button>
      </Box>
    </Paper>
  );
};

export default CookieBanner;
